export default __webpack_public_path__ + "static/datahexagons-31b9e96fe55caef65a0c16477db36b02.svg";